import { render, staticRenderFns } from "./UserAccordiant.vue?vue&type=template&id=161723f4"
import script from "./UserAccordiant.vue?vue&type=script&lang=js"
export * from "./UserAccordiant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports